"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.preview.errors.noId': 'ID pagamento non fornito',
    'payment.preview.errors.loadFailed': 'Impossibile caricare i dettagli del pagamento',
    'payment.preview.refreshed': 'Dettagli pagamento aggiornati',
};
